<template>
  <div class="page-report">
    <HeaderMegaposData/>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <h2>Item Sales By Price</h2>
            </div>
            <FormSearch
              :searchParameter="form"
              :onChangeSearchParameter="onChangeSearchParameter"
              :selectAllBranch="false"
              :hidePhysicalBranchFilter="false"
              :totalDaySelect="60"
              @reload-data="getList(page)"
              @export="exportFile"
            ></FormSearch>
            <div
              class="row mt-4"
              style="min-height: 1120px"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="d-flex justify-content-end align-items-center mb-3">
                      <label class="global-search mb-0">Search:
                        <input
                          type="search"
                          v-model="searchKeyword"
                          @input="onKeywordSearch"
                        />
                      </label>
                    </div>
                    <div class="p-0 custom-table">
                      <table
                        class="table align-items-center mb-0 dataTable"
                        ref="dataTable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              <div class="pt-4">Row No</div>
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder position-relative"
                              >
                                <div
                                  class="pt-4"
                                  style="position: unset"
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      index + 1,
                                      item.field
                                    )
                                  "
                                >
                                  {{ item.label }}
                                </div>
                              </th>
                            </template>
                          </tr>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              <input
                                v-model="columnSearch[0]"
                                @input="searchColumn(0)"
                              />
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th class="text-center font-weight-bolder">
                                <input
                                  v-model="columnSearch[index + 1]"
                                  @input="searchColumn(index + 1)"
                                />
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="items && items.length">
                          <tr v-for="(value, key) in items" :key="key">
                            <td class="text-right text-xss w-5">
                              {{ key + 1 }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.branch_name }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.item_no }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.item_name }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.description }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value?.unit_price) }}
                            </td>
                            <td class="text-right text-xss">
                              {{ value?.qty }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value?.item_discount) }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value?.item_total) }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.group }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.type }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else class="no-data">
                          <tr>
                            <td :colspan="headersData.length + 1" class="text-left">No matching records found</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="total-row">
                            <td class="text-right text-xss">TOTAL</td>
                            <td class="text-left text-xss"></td>
                            <td class="text-left text-xss"></td>
                            <td class="text-left text-xss"></td>
                            <td class="text-left text-xss"></td>
                            <td class="text-right text-xss"></td>
                            <td class="text-right text-xss">{{ totalQty }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totalItemDiscount) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totalItemTotal) }}</td>
                            <td class="text-left text-xss"></td>
                            <td class="text-left text-xss"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
                    <div class="rows-per-page">
                      <span class="rows-per-page__label">Rows per page</span>
                      <div class="rows-per-page__control">
                        <select v-model="limit" @change="setLimitPerPage" class="rows-per-page__select">
                          <option :value="20">20</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                    <pagination
                      v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/analytics/item-sales-by-price/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="physical_branch_id" :value="form.physical_branch_id" />
      <!-- <input type="hidden" name="branch_id" :value="form.branch_id" /> -->
      <input type="hidden" name="from_date" :value="from_date_export" />
      <input type="hidden" name="to_date" :value="to_date_export" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import AnalyticsService from "../../services/analytics.service";
import CommonFunctionService from "../../services/commonFunction.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import FormSearch from "./components/FormSearch.vue";
import Pagination from '@/components/Pagination.vue'
import HeaderMegaposData from "./components/HeaderMegaposData.vue";

export default {
  name: "item-sales-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    Pagination,
    HeaderMegaposData,
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      items: null,
      form: {
        physical_branch_id: -1,
        branch_id: -1,
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
      },
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      action_export: "csv",
      from_date_export: "",
      to_date_export: "",
      dataTable: null,
      tableData: [],
      columnSearch: [],
      pagination: {},
      page: 1,
      totalItemTotal: 0,
      totalItemDiscount: 0,
      totalQty: 0,
      searchTimer: null,
      searchKeyword: "",
      limit: 20,
    };
  },
  created() {
    // Fixed-size search model (Row No + every column), initialised once so
    // getList never wipes what the user typed on a search-triggered reload.
    this.columnSearch = new Array(this.headersData.length + 1).fill("");
  },
  computed: {
    headersData() {
      return [
        {
          label: "Branch",
          field: "branch_name",
          hasSortBy: true,
        },
        {
          label: "Itemno",
          field: "item_no",
          hasSortBy: true,
        },
        {
          label: "Itemname",
          field: "item_name",
          hasSortBy: true,
        },
        {
          label: "Description",
          field: "description",
          hasSortBy: true,
        },
        {
          label: "Unitprice",
          field: "unit_price",
          hasSortBy: true,
        },
        {
          label: "Quantity",
          field: "quantity",
          hasSortBy: true,
        },
        {
          label: "Item Discount",
          field: "item_discount",
          hasSortBy: true,
        },
        {
          label: "Itemtotal",
          field: "item_total",
          hasSortBy: true,
        },
        {
          label: "Group",
          field: "group",
          hasSortBy: true,
        },
        {
          label: "Type",
          field: "type",
          hasSortBy: true,
        },
      ];
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    formatPrice(price) {
      return (
        "$ " + price.toLocaleString("en-US", { minimumFractionDigits: 2 })
      );
    },

    exportFile(type = "csv") {
      this.action_export = type;
      this.from_date_export = this.dateFormat(this.form.from_date);
      this.to_date_export = this.dateFormat(this.form.to_date);
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    onChangeSearchParameter(value, fieldName) {
      this.form[fieldName] = value !== null ? value : "-1";
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    buildColumnSearch() {
      const search = {};
      this.headersData.forEach((header, index) => {
        const value = this.columnSearch[index + 1];
        if (
          header.field &&
          value !== undefined &&
          value !== null &&
          String(value).trim() !== ""
        ) {
          search[header.field] = String(value).trim();
        }
      });
      return search;
    },

    searchColumn() {
      // Debounce so we query the server once the user pauses typing; reset to
      // page 1 because the filtered result set (and its total) changes.
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getList(1);
      }, 500);
    },

    onKeywordSearch() {
      // Global search — same server round-trip as the per-column search.
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getList(1);
      }, 500);
    },

    handleChangeSortColumn(idx, field) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      // Sort on the server so it orders the whole result set, not just this page.
      this.getList(this.page);
    },

    getList(page) {
      this.showLoader();
      var dataForm = {
        physical_branch_id: this.form.physical_branch_id,
        // branch_id: this.form.branch_id,
        from_date: this.dateFormat(this.form.from_date),
        to_date: this.dateFormat(this.form.to_date),
        page: page,
        column_search: this.buildColumnSearch(),
        keyword: this.searchKeyword,
        sort_field: this.ESortDirectionSelect.field,
        sort_type: this.ESortDirectionSelect.direction,
        limit: this.limit,
      };

      AnalyticsService.itemSalesByPriceReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data
            this.items = data.data.items
            this.pagination = data.data
            this.page = this.pagination.current_page
            this.totalRecords = this.pagination.total
            this.totalItemTotal = data.total_item_total ?? 0
            this.totalItemDiscount = data.total_item_discount ?? 0
            this.totalQty = data.total_qty ?? 0

            if (
              this.pagination.current_page > this.pagination.last_page &&
              this.pagination.total > 0
            ) {
              this.page = 1
              this.getList(this.page)
              return
            }

            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: this.page }),
            })

            this.isLoadDone = true;
            this.isLoadDoneDataTable = true;
            this.hideLoader();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    setLimitPerPage() {
      // Reset to page 1 when changing limit
      this.page = 1;
      this.getList(1);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
  padding-top: 7px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

tfoot tr.total-row {
  font-weight: bold;
  color: #222;
  background: #e9edf2;
}

tfoot tr.total-row td {
  border-top: 2px solid #dee2e6;
}

/* Horizontal scroll lives in the table region; the page scrolls vertically. */
.custom-table {
  overflow-x: auto;
}

/* Column search inputs, styled like POS Daily Collection */
.custom-table table.dataTable thead th input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px 8px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  color: #495057;
  font-weight: normal;
}

.custom-table table.dataTable thead th input:focus {
  outline: none;
  border-color: #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}

/* Global "Search:" box */
.global-search {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.global-search input {
  padding: 6px 12px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  font-weight: normal;
  color: #495057;
  background: #fff;
  min-width: 220px;
}

.global-search input:focus {
  outline: none;
  border: 1px solid #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}
/* Empty-state ("No matching records found") cell: keep the same left/right
   grid borders as the data rows (the width-only rules do not render on a
   single colspan cell). */
.custom-table tbody.no-data > tr > td {
  border-left: 1px solid #dee2e6 !important;
  border-right: 1px solid #dee2e6 !important;
}
</style>
